import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  dropzoneLogoThumb: {
    display: 'inline-flex',
    borderRadius: '4px',
    maxWidth: '100%',
    boxSizing: 'border-box',
    flex: 1,
    background: '#FDFDFD',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  uploadLogo: {
    display: 'flex',
    position: 'relative',
    bottom: '44px',
    width: '100%',
    padding: '12px 0px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0px 0px 4px 4px',
    background: 'rgba(51, 51, 51, 0.16)',
    textShadow: '1px 1px 2px #fff',

    '&:hover': {
      background: 'rgba(51, 51, 51, 0.26)',
    },
  },
  deleteLogo: {
    display: 'flex',
    position: 'relative',
    width: '100%',
    padding: '12px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0px 4px 0px 0px',
    background: 'rgba(255, 49, 0, 0.08)',

    '&:hover': {
      background: 'rgba(255, 49, 0, 0.18)',
    },
  },
  dropzoneImg: {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '4px',
  },
  showImage: {
    display: 'none',
  },
  logoImage: {
    flex: '1',
    display: 'flex',
    width: '256px',
    marginBottom: '32px',
    minHeight: '256px',
    maxHeight: '256px',
    cursor: 'pointer',

    [theme.breakpoints.down('sm')]: {
      maxWidth: 'unset',
    },
  },
  dropzone: {
    display: 'flex',
    border: '1px dashed #E0E0E0',
    borderRadius: 4,
    flex: 1,
    background: '#FDFDFD',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: 16,
    flexDirection: 'column',
    width: '100%',
  },
  dropzoneDisabled: {
    border: '1px solid #b4b4b4',
    background: '#F2F2F2',
  },
}));
